const CustomRadioBtn = ({ value, name, label, title, onChange, checked }) => {
  return (
    <>
      <div className="form-group w-100">
        <div className="custom-label fw-bold d-flex " style={{ color: "#CACCFC" }}>
          {title}
        </div>
        <div className="input-wrapper d-flex align-items-center justify">
          <input className="form-check-input mb-1" type="radio" checked={checked} value={value} name={name} onChange={onChange} style={{ backgroundColor: "transparent" }} />
          <div className="custom-label fw-bold ms-2" style={{ color: "white", fontSize: "17px" }}>
            {label}
          </div>
        </div>
        <div className="input-underline" />
      </div>
    </>
  );
};

export default CustomRadioBtn;

// const handleChange = (event) => {
//     const name = event.target.name;
//     const value = name === "englishLevel" ? Number(event.target.value) : event.target.type === "checkbox" ? event.target.checked : event.target.value;
//     setData({
//       ...data,
//       [name]: value,
//     });
//   };
